import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { createLabelCommonRoot } from "./label-common";

type MuiInputLabel = {
  styleOverrides: ComponentsOverrides<Theme>["MuiInputLabel"];
  defaultProps?: ComponentsProps["MuiInputLabel"];
};

const muiInputLabel: MuiInputLabel = {
  styleOverrides: {
    root: ({ ownerState, theme }) => (ownerState.variant === "filled" ? createLabelCommonRoot(theme) : {}),
    shrink: ({ ownerState }) => ({
      ...(ownerState.variant !== "filled" && {
        transform: "translate(12px, -9px) scale(0.75)",
      }),
    }),
    sizeSmall: ({ ownerState }) => ({
      ...(ownerState.variant !== "filled" && {
        transform: "translate(14px, 9px) scale(1)",
        "&.MuiInputLabel-shrink": {
          transform: "translate(14px, -9px) scale(0.75)",
        },
      }),
    }),
  },
};

export default muiInputLabel;
